import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from './eagle_logo.png';
import { FaLock } from 'react-icons/fa';

const Navbar = () => {
  const [shrink, setShrink] = useState(false);
  const [menuActive, setMenuActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShrink(true);
      } else {
        setShrink(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  return (
    <nav className={`navbar ${shrink ? 'shrink' : ''} ${menuActive ? 'hamburger-active' : ''}`}>
      {/* Header: Logo links, Hamburger rechts */}
      <div className="navbar-header">
        <div className="navbar-left">
          <a href="https://eaglescript.space/" className="navbar-logo-link">
            <img src={logo} alt="Logo" className="navbar-logo" />
          </a>
        </div>
        <div className="navbar-hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      
      {/* Content: Navigation & Login (wird in Mobile via Hamburger ein-/ausgeblendet) */}
      <div className={`navbar-content ${menuActive ? 'active' : ''}`}>
        <ul className="navbar-menu">
          <li>
            <a
              href="https://eaglescript.space/"
              onClick={() => setMenuActive(false)}
            >
              Home
            </a>
          </li>
          <li>
            <a href="#features" onClick={() => setMenuActive(false)}>
              Features
            </a>
          </li>
          <li>
            <a href="#reviews" onClick={() => setMenuActive(false)}>
              Reviews
            </a>
          </li>
          <li>
            <a href="#pricing" onClick={() => setMenuActive(false)}>
              Pricing
            </a>
          </li>
        </ul>
        <div className="navbar-right">
          <a href="#private-login" className="private-login-link" onClick={() => setMenuActive(false)}>
            <FaLock className="lock-icon" />
            <span className="login-text">Private Login</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
